import { APP_PREFIX_PATH } from 'configs/AppConfig';
import { UserType } from 'schemas/user.schemas';

/** Post-login landing path for Ads Manager. */
export const ADS_MANAGER_DEFAULT_PATH = `${APP_PREFIX_PATH}/architect-images/list`;

/** Post-login landing path for superadmin. */
export const SUPERADMIN_DEFAULT_PATH = `${APP_PREFIX_PATH}/dashboards/default`;

export const ADMIN_ACCESS_REQUIRED_MESSAGE = 'Admin access required.';

/**
 * @param {{ type?: number | string } | null | undefined} user
 * @returns {boolean}
 */
export function isAdminPanelUser(user) {
  if (user == null || user.type == null) {
    return false;
  }
  const type = Number(user.type);
  return type === UserType.SUPERADMIN || type === UserType.ADS_MANAGER;
}

/**
 * @param {{ type?: number | string } | null | undefined} user
 * @returns {boolean}
 */
export function isAdsManager(user) {
  if (user == null || user.type == null) {
    return false;
  }
  return Number(user.type) === UserType.ADS_MANAGER;
}

/**
 * @param {{ type?: number | string } | null | undefined} user
 * @returns {string}
 */
export function getAuthenticatedEntryPath(user) {
  return isAdsManager(user) ? ADS_MANAGER_DEFAULT_PATH : SUPERADMIN_DEFAULT_PATH;
}

const ADS_MANAGER_ALLOWED_PATHS = [
  `${APP_PREFIX_PATH}/architect-images/list`,
  `${APP_PREFIX_PATH}/pages/setting/edit-profile`,
  `${APP_PREFIX_PATH}/pages/setting/change-password`,
];

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isPathAllowedForAdsManager(pathname) {
  const normalized = (pathname || '').replace(/\/$/, '') || '/';
  return ADS_MANAGER_ALLOWED_PATHS.some(
    (allowed) => normalized === allowed || normalized.startsWith(`${allowed}/`),
  );
}

/**
 * @param {Array<Record<string, unknown>>} navConfig
 * @param {{ type?: number | string } | null | undefined} user
 * @returns {Array<Record<string, unknown>>}
 */
export function filterNavigationForUser(navConfig, user) {
  if (!isAdsManager(user)) {
    return navConfig;
  }

  return navConfig
    .filter((item) => item.key === 'media')
    .map((item) => ({
      ...item,
      path: ADS_MANAGER_DEFAULT_PATH,
      submenu: (item.submenu || []).filter(
        (sub) => sub.key === 'architect-images.list',
      ),
    }));
}
